import React from 'react';
import { QuantitySelector } from './QuantitySelector';
interface CheckoutProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
}
export function Checkout({
  quantity,
  onQuantityChange
}: CheckoutProps) {
  const pricePerUnit = 65;
  const total = pricePerUnit * quantity;
  return <section id="checkout" className="py-24 px-6 border-t border-gray-100 scroll-mt-20" data-id="element-1">
      <div className="max-w-xl mx-auto" data-id="element-2">
        <h2 className="text-2xl font-light text-center mb-12" data-id="element-3">
          Payment – £{pricePerUnit}
        </h2>

        <div className="border border-gray-200 p-8 md:p-12 space-y-8" data-id="element-4">
          {/* Order Summary */}
          <div className="space-y-6" data-id="element-5">
            <div className="flex items-center justify-between pb-4 border-b border-gray-100" data-id="element-6">
              <span className="text-sm font-light" data-id="element-7">The Candle</span>
              <span className="text-sm" data-id="element-8">£{pricePerUnit}</span>
            </div>

            <div className="flex items-center justify-between" data-id="element-9">
              <span className="text-sm font-light" data-id="element-10">Quantity</span>
              <QuantitySelector quantity={quantity} onQuantityChange={onQuantityChange} size="sm" data-id="element-11" />
            </div>

            <div className="flex items-center justify-between text-lg font-medium pt-4 border-t border-gray-100" data-id="element-12">
              <span data-id="element-13">Total</span>
              <span data-id="element-14">£{total}</span>
            </div>
          </div>

          {/* Explanation Text */}
          <p className="text-sm text-gray-600 leading-relaxed font-light" data-id="element-15">
            These details are needed to design your personalised candle,
            including a custom version with your face on it.
          </p>

          {/* Form Fields */}
          <div className="space-y-4" data-id="element-16">
            <div data-id="element-17">
              <label className="block text-sm mb-2 font-light" data-id="element-18">
                Full name <span className="text-red-500" data-id="element-19">*</span>
              </label>
              <input type="text" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-20" />
            </div>

            <div data-id="element-21">
              <label className="block text-sm mb-2 font-light" data-id="element-22">
                Date of birth <span className="text-red-500" data-id="element-23">*</span>
              </label>
              <input type="date" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-24" />
            </div>

            <div data-id="element-25">
              <label className="block text-sm mb-2 font-light" data-id="element-26">
                Upload photo (JPG/PNG) <span className="text-red-500" data-id="element-27">*</span>
              </label>
              <input type="file" accept="image/jpeg,image/png" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm file:mr-4 file:py-2 file:px-4 file:border-0 file:text-sm file:bg-gray-50 file:text-gray-700 hover:file:bg-gray-100" data-id="element-28" />
            </div>

            <div data-id="element-29">
              <label className="block text-sm mb-2 font-light" data-id="element-30">
                Address line 1 <span className="text-red-500" data-id="element-31">*</span>
              </label>
              <input type="text" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-32" />
            </div>

            <div data-id="element-33">
              <label className="block text-sm mb-2 font-light" data-id="element-34">
                Address line 2
              </label>
              <input type="text" className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-35" />
            </div>

            <div data-id="element-36">
              <label className="block text-sm mb-2 font-light" data-id="element-37">
                City / Town <span className="text-red-500" data-id="element-38">*</span>
              </label>
              <input type="text" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-39" />
            </div>

            <div data-id="element-40">
              <label className="block text-sm mb-2 font-light" data-id="element-41">
                Postcode <span className="text-red-500" data-id="element-42">*</span>
              </label>
              <input type="text" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-43" />
            </div>

            <div data-id="element-44">
              <label className="block text-sm mb-2 font-light" data-id="element-45">
                Country <span className="text-red-500" data-id="element-46">*</span>
              </label>
              <select required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-47">
                <option data-id="element-48">United Kingdom</option>
                <option data-id="element-49">United States</option>
                <option data-id="element-50">Canada</option>
                <option data-id="element-51">Australia</option>
                <option data-id="element-52">Other</option>
              </select>
            </div>

            <div data-id="element-53">
              <label className="block text-sm mb-2 font-light" data-id="element-54">
                Snapchat username <span className="text-red-500" data-id="element-55">*</span>
              </label>
              <input type="text" required className="w-full px-4 py-3 border border-gray-200 focus:border-gray-400 focus:outline-none transition-colors text-sm" data-id="element-56" />
            </div>
          </div>

          {/* Payment Button */}
          <div className="space-y-3 pt-4" data-id="element-57">
            <a href="https://buy.stripe.com/4gMdR99cr4w15fD5cHeZ200" className="block w-full py-4 bg-black text-white text-sm tracking-wider hover:bg-gray-800 transition-colors text-center" data-id="element-58">
              Pay £{total} securely
            </a>
            <p className="text-xs text-gray-500 text-center font-light" data-id="element-59">
              Secure checkout • Encrypted payment
            </p>
          </div>

          {/* Privacy Note */}
          <p className="text-xs text-gray-400 font-light text-center pt-4 border-t border-gray-100" data-id="element-60">
            Your details are used only to personalise and deliver your candle.
          </p>
        </div>
      </div>
    </section>;
}